import React, { useEffect, useState } from "react";
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogFooter,
    AlertDialogAction,
} from "../../../../components/ui/AlertDialog";
import { AlertCircle } from "lucide-react";

interface IdleErrorDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onReturnHome?: () => void;
}

const IdleErrorDialog = ({
    isOpen,
    onOpenChange,
    onReturnHome,
}: IdleErrorDialogProps) => {
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isOpen) {
            // Reset countdown when dialog opens
            setCountdown(10);

            // Start countdown
            timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        handleAction();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timer) clearInterval(timer);
        };
    }, [isOpen]);

    const handleAction = () => {
        onOpenChange(false);
        if (onReturnHome) {
            onReturnHome();
        }
    };

    return (
        <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
            <AlertDialogContent className="max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2 text-red-600">
                        <AlertCircle className="h-5 w-5" />
                        <span>Interview Error</span>
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-base space-y-2">
                        <p className="text-gray-700 font-medium">
                            You are idle for too long. This interview session
                            has been closed.
                        </p>
                        <p className="text-gray-600">
                            Please return to the homepage and try starting a new
                            interview session.
                        </p>
                        <p className="text-sm text-red-500 font-medium mt-4">
                            Returning to homepage in {countdown} seconds...
                        </p>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction
                        onClick={handleAction}
                        className="bg-red-600 text-white hover:bg-red-700">
                        Return to Homepage Now
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default IdleErrorDialog;
